import { useRiseIdStore } from "~~/store/riseId";
import { useSessionStore } from "~~/store/session";
import { useWalletStore } from "~~/store/wallet";
import blockchainService from "@/services/blockchain";

export default {
  data() {
    return {
      loadingMigrateFund: false,
    };
  },
  computed: {
    riseId() {
      const sessionStore = useSessionStore();
      return sessionStore.riseId;
    },
    riseIdOwner() {
      const riseIdStore = useRiseIdStore();
      return riseIdStore.owner;
    },
    delegates() {
      const riseIdStore = useRiseIdStore();
      return riseIdStore.delegates;
    },
  },

  async mounted() {
    this.getRiseIdOwner();
    const riseIdStore = useRiseIdStore();
    await riseIdStore.getDelegates();
  },

  methods: {
    async getBalance() {
      this.loadingMigrateFund = true;
      try {
        const sessionStore = useSessionStore();
        await sessionStore.getBalance();
      } finally {
        this.loadingMigrateFund = false;
      }
    },
    async getRiseIdOwner(refresh = false) {
      if (!this.riseIdOwner || refresh) {
        const sessionStore = useSessionStore();
        await sessionStore.me();
        const riseIdStore = useRiseIdStore();
        await riseIdStore.getOwner(this.riseId);
      }
    },
    async migrateFund(amount) {
      if (!amount) {
        this.$toastError("Provide amount to migrate");
        return;
      }

      this.loadingMigrateFund = true;
      try {
        const walletStore = useWalletStore();

        if (!walletStore.isActive) await walletStore.connectWallet();
        const wallet = await walletStore.walletAddress;

        if (!wallet) {
          this.$sentryCaptureException(
            new Error(
              `migrateFund: wallet address unresolved after connect (isActive=${walletStore.isActive}, walletType=${walletStore.walletType})`
            )
          );
          this.$toastError("We couldn't verify your account. Please refresh the page and try again.");
          return;
        }

        const isDelegate = this.delegates?.some(
          (d) => d.toLowerCase() === wallet.toLowerCase()
        );
        if (
          this.riseIdOwner?.toLowerCase() !== wallet.toLowerCase() &&
          !isDelegate
        ) {
          this.$toastError("Wallet connected must be the owner");
          return;
        }

        const { data: response } = await blockchainService.putDynamic(
          "transfer-to-v2",
          {
            rise_id: this.riseId,
            amount,
            wallet,
          }
        );

        const { data: payload } = response;

        const signature = await walletStore.signTypedData(payload);

        await blockchainService.postDynamic(
          "transfer-to-v2",
          {
            amount,
            wallet,
            signature,
            request: payload.message,
          },
          {
            rise_id: this.riseId,
            wallet,
          }
        );

        this.$toastSuccess("Fund successfully transferred.");

        await this.getBalance(true);
      } catch (e) {
        this.$toastError("Error occurred while transferring funds.");
        this.$sentryCaptureException(e);
      } finally {
        this.$loader.hide();
        this.loadingMigrateFund = false;
      }
    },
  },
};
